<div class="w-full overflow-hidden">
  <div class="flex flex-col relative">
    @if (direction === 'bottom' || offsetDirection === 'top') {
      @for (action of actions | filterBy:'position':'top'; track action) {
        @if (!action.isVisible || (action.isVisible | async)) {
          <soft-swipe-action
            [action]="action"
            class="absolute top-0 h-full">
          </soft-swipe-action>
        }
      }
    }
    <div class="flex flex-row relative w-full">
      @if (direction === 'right' || offsetDirection === 'left') {
        @for (action of actions | filterBy:'position':'left'; track action) {
          @if (!action.isVisible || (action.isVisible | async)) {
            <soft-swipe-action
              [action]="action"
              class="absolute left-0 h-full">
            </soft-swipe-action>
          }
        }
      }
      <div class="w-full z-10"
        [ngStyle]="{'transform': distance | swipeContainerTransform : direction}">
        <ng-content></ng-content>
      </div>
      @if (direction === 'left' || offsetDirection === 'right') {
        @for (action of actions | filterBy:'position':'right'; track action) {
          @if (!action.isVisible || (action.isVisible | async)) {
            <soft-swipe-action
              [action]="action"
              class="absolute right-0 h-full">
            </soft-swipe-action>
          }
        }
      }
    </div>
    @if (direction === 'top' || offsetDirection === 'bottom') {
      @for (action of actions | filterBy:'position':'bottom'; track action) {
        @if (!action.isVisible || (action.isVisible | async)) {
          <soft-swipe-action
            [action]="action"
            class="absolute bottom-0 h-full">
          </soft-swipe-action>
        }
      }
    }
  </div>
</div>
